/*
 * Purpose: Legacy /builder redirect to new IA routes
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { Navigate, useLocation } from 'react-router-dom';
import { resolveBuilderLegacyRedirect } from '@/lib/builderRedirects';

export default function BuilderLegacyRedirect() {
  const location = useLocation();
  const target = resolveBuilderLegacyRedirect(location.search);
  return <Navigate to={target} replace />;
}
